import { render, staticRenderFns } from "./addIconsvg.vue?vue&type=template&id=52d21d15&"
import script from "./addIconsvg.vue?vue&type=script&lang=js&"
export * from "./addIconsvg.vue?vue&type=script&lang=js&"
import style0 from "./addIconsvg.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports